import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Tabs } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ssoLogin } from '../../utils/ssologin';


function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loginType, setLoginType] = useState('account');


  const handleLogin = async (values) => {
    if (loginType === 'account') {
      const result = await ssoLogin(values.username, values.password);
      if (result.success) {
        if (result.type === 2) {
          message.error('外业工作人员无权限登录管理后台');
          return;
        }
        message.success('登录成功');
        navigate('/admin/tickets');
      } else {
        message.error(result.message);
      }
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#fff',
      backgroundImage: 'url(' + require('../../login_background.png') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div style={{ marginBottom: 40, textAlign: 'center' }}>
        <h1 style={{ 
          fontSize: 33,
          fontWeight: 600,
          color: 'rgba(0, 0, 0, 0.85)',
          marginTop: 12
        }}>水务巡查系统</h1>
        <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>常州壹城工程科技有限公司</div>
      </div>

      <Card
        style={{
          width: 400,
          borderRadius: 8,
          backgroundColor: 'transparent',
          border: 'none'
        }}
        bodyStyle={{
          background: 'transparent'
        }}
      >
        <Tabs
          activeKey={loginType}
          onChange={setLoginType}
          centered
          items={[{
            
              key: 'account',
              label: '账户密码登录',
              children: (
                <Form
                  form={form}
                  onFinish={handleLogin}
                  autoComplete="off"
                >
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: '请输入用户名' }]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="请输入用户名"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: '请输入密码' }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="请输入密码"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item style={{ marginBottom: 0, marginTop: -16 }}>
                    <Button
                      type="link"
                      style={{ padding: 0, fontSize: '12px' }}
                      onClick={() => message.info('请联系超级管理员帮您重置密码')}
                    >
                      忘记密码？
                    </Button>
                  </Form.Item>
                  
                </Form>
              ),
            }
            
          ]}
        />

        <Button
          type="primary"
          size="large"
          block
          onClick={() => form.submit()}
          style={{ marginTop: 24 }}
        >
          登录
        </Button>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          marginTop: 24 
        }}>
          
        </div>
      </Card>
      <div style={{
        marginTop: '60px',
        color: '#000',
        fontSize: '14px',
        textAlign: 'center'
      }}>
        <span>©Powered by 常州壹城工程科技有限公司</span>
      </div>
    </div>
  );
}

export default Login;